import { lazy, type ComponentType } from "react";

const RELOAD_KEY = "chunk-reload-attempted";

// Wrap React.lazy so that a failed dynamic import (stale chunk after a new
// deploy) triggers a one-shot page reload instead of surfacing as an uncaught
// "Importing a module script failed." TypeError. The sessionStorage flag
// prevents a reload loop when the failure is genuinely not a stale-chunk issue.
export function lazyWithRetry<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      const mod = await factory();
      sessionStorage.removeItem(RELOAD_KEY);
      return mod;
    } catch (err) {
      if (!sessionStorage.getItem(RELOAD_KEY)) {
        sessionStorage.setItem(RELOAD_KEY, "1");
        window.location.reload();
        return new Promise<{ default: T }>(() => {});
      }
      throw err;
    }
  });
}
